// rules/rule-0029-assistant-anaes.ts
import { BaseRule } from '../rule-base';
import { AdjustedLine, ModifierContext } from '../modifier-models';

export class Rule0029AssistantAnaes extends BaseRule {
    name = '0029 assistant-anaesthesiologist';

    run(line: AdjustedLine, ctx: ModifierContext, autoApply: boolean): void {
        if (line.code !== '0029') return;

        // Since we don't have access to all lines in the run method,
        // we'll need to rely on the apply method for this rule
        if (autoApply) {
            line.trace.push('0029: Requires full context for calculation');
        } else {
            line.suggestions = line.suggestions || [];
            line.suggestions.push({
                ruleCode: '0029',
                message: 'Assistant anaesthesiologist calculation requires full context',
                kind: 'overwrite'
            });
        }
    }

    apply(lines: AdjustedLine[], ctx: ModifierContext): AdjustedLine[] {
        const row = lines.find(l => l.code === '0029');
        if (!row) return lines;

        const total = lines
            .filter(l => l.meta?.['discipline'] === 'anaesthetic' && !l.isModifier && !l.isConsult)
            .reduce((s: number, l: AdjustedLine) => s + l.adjustedUnits, 0);

        if (total) {
            row.adjustedUnits = total;               // GP basis = full units
            row.trace.push('0029 = full GP units');
        }
        return lines;
    }
}
